export default __webpack_public_path__ + "static/media/information--bus-stop--g1.a7ecbcd5.png";